import React from 'react'
import SidebarLeft from '../SideBarLeft/SidebarLeft'

import {Layout } from 'antd';
const MainLayout=() =>{
    return (

        <Layout className="100vh">
            <SidebarLeft /> 
        </Layout>
       
    )
}

export default MainLayout
